import { render, staticRenderFns } from "./formCreateVehicle.vue?vue&type=template&id=1b83e687"
import script from "./formCreateVehicle.vue?vue&type=script&lang=js"
export * from "./formCreateVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b83e687')) {
      api.createRecord('1b83e687', component.options)
    } else {
      api.reload('1b83e687', component.options)
    }
    module.hot.accept("./formCreateVehicle.vue?vue&type=template&id=1b83e687", function () {
      api.rerender('1b83e687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/vehicle/components/form/formCreateVehicle.vue"
export default component.exports